// state.js

export default {
    conditionsList: [],
};
